import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { filter, first, map, tap } from "rxjs/operators";
import { RoutingNames } from "src/app/shared/enums/routes-names";
import { b2bRedirectPath } from "src/app/shared/guards/b2b-redirect-path";
import { UserAccessRegulatorService } from "src/app/shared/services/user-access-regulator.service";

export const dashboardGuard = () => {
  const userAccessRegulator = inject(UserAccessRegulatorService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  if (userAccessRegulator.hasAccessToAdmin) {
    return void router.navigate([RoutingNames.B2B_OPS, RoutingNames.B2B_OPS_DASHBOARD]);
  }

  if (userAccessRegulator.hasAccessToClientB2B) {
    return void router.navigate(b2bRedirectPath(userAccessRegulator));
  }

  return msalBroadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    first(),
    map(() => userAccessRegulator.hasAccessToVictim),
    tap((hasPermission) => {
      return hasPermission;
    }),
  );
};
